<template>
  <mailchimp-subscribe
    url="https://band.us7.list-manage.com/subscribe/post-json"
    user-id="09a2f0bda359917ad9441448b"
    list-id="ba0caca23c"
    @error="onError"
    @success="onSuccess"
  >
    <template v-slot="{ subscribe, setEmail, error, success, loading }">
      <div class="newsletter padding-mobile section-margin container hidden">
          <h2>We are proud of what we do and we want to share this with you</h2>
          <p>Follow our development process and be part of our story. By filling in the form, we will send you updates whenever we reach a milestone within our process. relaxY is a product for the meditating community. We really would like to invite the community into our process.</p>
          <form @submit.prevent="subscribe" class="newsletter-inputs">
          <input type="email" @input="setEmail($event.target.value)" class="newsletter-input" placeholder="Your email">
          <button type="submit" class="subscribe-btn">Subscribe now!</button>
          <div v-if="error">{{ error }}</div>
          <div v-if="success" class="success">Awesome! You have now registered to receive updates from Relaxy.</div>
          <div v-if="loading">Loading…</div>
        </form>
      </div>
    </template>
  </mailchimp-subscribe>
</template>



<script>
import MailchimpSubscribe from 'vue-mailchimp-subscribe'

export default {
  components: {
    MailchimpSubscribe,
  },
  methods: {
    onError() {
      // handle error
    },
    onSuccess() {
      // handle success
    },
  },
}
</script>

<style scoped>

.newsletter {
  margin-top: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.newsletter-inputs {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: #B1B1B1;
  width: 100%;
}

.newsletter-input {
  border: 2px solid #17212C;
  border-radius: 5px;
  height: 20px;
  padding: 15px 0 15px 20px;
}
.newsletter-input:last-child {
  margin-top: 20px;
}

.subscribe-btn {
  border-radius: 5px;
  background-color: #FFB95C;
  padding: 17px 30px 17px 30px;
  display: inline;
  box-shadow: 0px 3px 6px #00000029;
  margin-top: 20px;
  border:none;
  font-size: 18px;
}

.success {
  margin-top: 10px;
  color: #FFB95C;
}

.hidden {
  display: none !important;
}

</style>